import type { HTMLAttributes, ReactNode } from "react";
import type { LearningMethod } from "../../domain/models";

export type BadgeTone = "neutral" | "accent" | "danger";
export type StudyPriority = "S" | "A" | "B";

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  children: ReactNode;
  tone?: BadgeTone;
  priority?: StudyPriority;
}

export function Badge({ children, className, tone = "neutral", priority, ...props }: BadgeProps) {
  return (
    <span
      {...props}
      className={["ui-badge", className].filter(Boolean).join(" ")}
      data-priority={priority}
      data-tone={tone}
    >
      {children}
    </span>
  );
}

const learningMethodLabels: Record<LearningMethod, { tag: string; label: string }> = {
  memorize: { tag: "背", label: "记忆提取" },
  understand: { tag: "懂", label: "理解关系" },
  calculate: { tag: "算", label: "计算应用" },
  case: { tag: "案", label: "案例作答" },
};

export function LearningMethodBadge({ method }: { method: LearningMethod }) {
  const item = learningMethodLabels[method];

  return (
    <Badge
      aria-label={`学习方法：[${item.tag}] ${item.label}`}
      className="learning-method-badge"
      data-method={method}
    >
      <span aria-hidden="true" className="learning-method-badge__tag">[{item.tag}]</span>
      <span>{item.label}</span>
    </Badge>
  );
}
